exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".OtherFlow-dc721d5b{position:relative}.OtherFlow-dc721d5b .instructions-8e672c46{text-align:center;max-width:500px;margin:0 auto}\n", ""]);

// Exports
exports.locals = {
	"OtherFlow": "OtherFlow-dc721d5b",
	"instructions": "instructions-8e672c46"
};